import { IAppState } from "../../../store/reducers";

import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const td1Routes: Record<string, string> = {
	AB: "alberta",
	BC: "british_columbia",
	MB: "manitoba",
	NB: "new_brunswick",
	NL: "newfoundland_and_labrador",
	NT: "northwest_territories",
	NS: "nova_scotia",
	NU: "nunavut",
	ON: "ontario",
	PE: "prince_edward_island",
	QC: "quebec",
	SK: "saskatchewan",
	YT: "yukon",
};

export const SlipsRoutesComponent = () => {
	const navigate = useNavigate();
	const provincesForTDForm = useSelector((state: IAppState) => state.dashboardApisData.provincesForTDForm)
	const ArrayData = [
		{
			label: "T4",
			items: [
				{
					label: "List",
					command: () => {
						navigate("/compliance/t4/list");
					},
				},
				{
					label: "Setup",
					command: () => {
						navigate("/compliance/t4/setup");
					},
				},
				{
					label: "Summary",
					command: () => {
						navigate("/compliance/t4/summary");
					},
				},
				{
					label: "Summary Reduced EI",
					command: () => {
						navigate("/compliance/t4/summary-reduced-ei");
					},
				},
			],
		},
		{
			label: "RL-1",
			items: [
				{
					label: "List",
					command: () => {
						navigate("/compliance/rl1/list");
					},
				},
				{
					label: "Setup",
					command: () => {
						navigate("/compliance/rl1/setup");
					},
				},
				{
					label: "Summary",
					command: () => {
						navigate("/compliance/rl1/summary");
					},
				},
				{
					label: "Settings",
					command: () => {
						navigate("/compliance/rl1/settings");
					},
				},
			],
		},

		// HEADING
		// {
		// 	label: "TD1",
		// 	menuHeaderLabel: true,
		// };
		{
			label: "TD1",
			items:
				// [
				// 	{
				// 		label: "Federal",
				// 		command: () => {
				// 			navigate("/td1/federal");
				// 		},
				// 	},
				// 	{
				// 		label: "AB",
				// 		command: () => {
				// 			navigate("/td1/alberta");
				// 		},
				// 	},
				// 	{
				// 		label: "BC",
				// 		command: () => {
				// 			navigate("/td1/british_columbia");
				// 		},
				// 	},

				// 		{
				// 		label: "MB",
				// 		command: () => {
				// 			navigate("/td1/manitoba");
				// 		},
				// 	},
				// 		{
				// 		label: "NB",
				// 		command: () => {
				// 			navigate("/td1/new_brunswick");
				// 		},
				// 	},
				// 		{
				// 		label: "NL",
				// 		command: () => {
				// 			navigate("/td1/newfoundland_and_labrador");
				// 		},
				// 	},
				// 		{
				// 		label: "NT",
				// 		command: () => {
				// 			navigate("/td1/northwest_territories");
				// 		},
				// 	},
				// 	{
				// 		label: "NS",
				// 		command: () => {
				// 			navigate("/td1/nova_scotia");
				// 		},
				// 	},
				// 	{
				// 		label: "NU",
				// 		command: () => {
				// 			navigate("/td1/nunavut");
				// 		},
				// 	},
				// 	{
				// 		label: "ON",
				// 		command: () => {
				// 			navigate("/td1/ontario");
				// 		},
				// 	},
				// 	{
				// 		label: "PE",
				// 		command: () => {
				// 			navigate("/td1/prince_edward_island");
				// 		},
				// 	},
				// 	{
				// 		label: "QC",
				// 		command: () => {
				// 			navigate("/td1/quebec");
				// 		},
				// 	},
				// 	{
				// 		label: "SK",
				// 		command: () => {
				// 			navigate("/td1/saskatchewan");
				// 		},
				// 	},
				// 	{
				// 		label: "YT",
				// 		command: () => {
				// 			navigate("/td1/yukon");
				// 		},
				// 	},

				// ],
				[
					{
						label: "Federal",
						command: () => navigate("/td1/federal"),
					},
					...Object.keys(td1Routes)
						.filter(code => provincesForTDForm?.[code])
						.map(code => ({
							label: code,
							command: () => navigate(`/td1/${td1Routes[code]}`),
						})),
				]
		},
		// {
		// 	label: "ROE",
		// 	menuHeaderLabel: true,
		// },
		{
			label: "ROE",
			items: [
				{
					label: "List",
					command: () => {
						navigate("/compliance/roe/list");
					},
				},
				{
					label: "Create",
					command: () => {
						navigate("/compliance/roe/setup");
					},
				},
				{
					label: "Web",
					command: () => {
						navigate("/");
					},
				},
			],
		},

	];

	return {
		SlipsRoutes: ArrayData,
	};
};
